import * as React from 'react';
import { Link, LinkProps } from 'react-router';
import { ButtonProps } from '../Button/Button';
import { button } from '../Button/base';
import { composeExternalLinkAttributes } from '../TextLink/utils';

type LinkElementRef = React.ElementRef<typeof Link>;
export type ButtonLinkProps = Omit<LinkProps, 'className'> &
  ButtonProps & {
    external?: boolean;
  };

// eslint-disable-next-line react-x/no-forward-ref -- TODO: Wait! Don't change this file without seeing if you can remove this disable. It was added during a bulk version update, but fixing it would leave the park nicer than you found it.
const ButtonLink = React.forwardRef<LinkElementRef, ButtonLinkProps>(
  (
    {
      external,
      intent,
      leadingIcon,
      trailingIcon,
      disabled,
      purpose,
      size,
      width = 'full',
      children,
      onClick,
      ...rest
    },
    forwardedRef,
  ) => {
    const { rel, target } = composeExternalLinkAttributes({
      external,
      rel: rest.rel,
      target: rest.target,
    });

    return (
      <Link
        {...rest}
        target={target}
        rel={rel}
        className={button({ intent, purpose, size, width })}
        data-intent={intent}
        aria-disabled={disabled}
        onClick={disabled ? (e) => e.preventDefault() : onClick}
        ref={forwardedRef}
      >
        {leadingIcon}
        {children}
        {trailingIcon}
      </Link>
    );
  },
);

ButtonLink.displayName = 'ButtonLink';

export { ButtonLink };
